import axios from "axios";
import _ from "lodash";
import Vue from 'vue'
import store from '../index.js.erb'
import PrtfAchievementKindApiService from "../../../components/application/portfolio/Services/Api/PrtfAchievementKindApi";
import {getField, updateField} from "vuex-map-fields";
import PrtfAchievementKindApiAdminService
    from "../../../components/application/portfolio/Services/Api/Admin/PrtfAchievementKind";
import PrtfAchievementUnitApiAdminService
    from "../../../components/application/portfolio/Services/Api/Admin/PrtfAchievementUnitApi";
import PrtfAchievementSubunitApiAdminService
    from "../../../components/application/portfolio/Services/Api/Admin/PrtfAchievementSubunitApi";

const PrtfAchKindApi = PrtfAchievementKindApiService;
const PrtfAchKindApiAdmin = PrtfAchievementKindApiAdminService;


const AchievementKindStore = {
    namespaced: true,
    state: ()=>({
        payload: {
            name: null,
            prtf_achievement_type_id: null,
            description: null,
            kind: null,
            kind_other: null,
            subgraph_order: null,
            status_event: null,
            status_event_other: null,
            organization: null,
            organization_other: null,
            organization_name: null,
            category_importance: null,
            participants_number: null,
            link_document: null,
            link_site: null,
            is_hidden: false,
            prtf_achievement_units_attributes: []
        },
        achievementKindsList: [],
        dialog: false,
        id_achievement_type: null,
        id_achievement_kind: null,
        edit_mode_form: false,
    }),

    getters: {
        getPayloadAchievementKind(state) {
            return getField(state.payload);
        },
    },

    mutations: {

        updatePayloadAchievementKind(state, field) {
            updateField(state.payload, field);
        },

        setAchievementKindsList: (state, response) => state.achievementKindsList = response,

        setDialog: (state, flag) => state.dialog = flag,

        setEditModeForm: (state, flag)=> state.edit_mode_form = flag,

        unshiftAchievementKindToList: (state, achievementKind) => state.achievementKindsList.unshift(achievementKind),

        spliceAchievementKindToList: (state, achievementKind) =>
            state.achievementKindsList.splice(_.findIndex(state.achievementKindsList,
                (i)=> i.id === achievementKind.id), 1),

        replaceAchievementKindToList: (state, achievementKind) => {
            const index_achievement = _.findIndex(state.achievementKindsList,
                (i)=> i.id === achievementKind.id);
            Vue.set(state.achievementKindsList, index_achievement, achievementKind);
        },

        pushUnitWithAchievement(state) {
            const units = state.payload.prtf_achievement_units_attributes
            units.push({name: "", score: 0.0, prtf_achievement_subunits_attributes: [], _index: units.length});
        },

        deleteUnitWithAchievement(state, index) {
            const unit = state.payload.prtf_achievement_units_attributes;

            if (_.has(unit[index], '_index')) {
                Vue.delete(unit, index);
            } else {
                Vue.set(unit, index, {id:unit[index].id, _destroy: 1});
            }
        },

        updateUnitData(state, data) {
            const { index, name, score } = data;
            state.payload.prtf_achievement_units_attributes[index].name = name;
            state.payload.prtf_achievement_units_attributes[index].score = Number(score);
        },

        pushSubunit(state, index) {
            const unit = state.payload.prtf_achievement_units_attributes[index];
            const subunit = unit.prtf_achievement_subunits_attributes;

            subunit.push({name: "", score: 0.0, _index:`subunit_${subunit.length}_${unit._index}`});
        },

        deleteSubunit(state, {indexUnit, indexSubunit}) {
            const unit = state.payload.prtf_achievement_units_attributes[indexUnit];
            const subunit = unit.prtf_achievement_subunits_attributes;

            if (_.has(subunit[indexSubunit], '_index')) {
                Vue.delete(subunit, indexSubunit);
            } else {
                Vue.set(subunit, indexSubunit, {id:subunit[indexSubunit].id, _destroy: 1});
            }
        },

        updateSubunitData(state, data) {
            const { indexUnit, indexSubunit, name, score } = data;
            const unit = state.payload.prtf_achievement_units_attributes[indexUnit];
            const subunit = unit.prtf_achievement_subunits_attributes[indexSubunit]

            subunit.name = name;
            subunit.score = Number(score);
        },

        setIdAchievementType(state, id) {
            state.id_achievement_type = id;
        },

        setAchievementEdit(state, achievement) {
            const payload = _.cloneDeep(achievement);

            state.payload = {
                id: state.id_achievement_kind,
                name: payload.name,
                prtf_achievement_type_id: state.id_achievement_type,
                description: payload.description,
                is_hidden: payload.is_hidden,
                kind: payload.kind,
                kind_other: payload.kind_other,
                subgraph_order: payload.subgraph_order,
                status_event: payload.status_event,
                status_event_other: payload.status_event_other,
                organization: payload.organization,
                organization_other: payload.organization_other,
                organization_name: payload.organization_name,
                category_importance: payload.category_importance,
                participants_number: payload.participants_number,
                link_document: payload.link_document,
                link_site: payload.link_site,
                prtf_achievement_units_attributes: _.map(payload.units, (unit) => {
                    return _.assign({}, unit, {
                        "prtf_achievement_subunits_attributes": unit.subunits
                    });
                }),
            };
        },

        resetAchievement(state) {
            state.payload = {
                name: null,
                prtf_achievement_type_id: null,
                description: null,
                is_hidden: false,
                prtf_achievement_units_attributes: []
            };
        },

        setIdAchievementKind(state, id) {
            state.id_achievement_kind = id;
        },

        TOGGLE_UNIT_HIDDEN(state, unitId) {
            const arr = state.payload.prtf_achievement_units_attributes;
            const idx = arr.findIndex(u => u.id === unitId || u._index === unitId);
            if (idx === -1) return;
            Vue.set(arr[idx], 'is_hidden', !arr[idx].is_hidden);
        },

        TOGGLE_SUBUNIT_HIDDEN(state, { unitId, subunitId }) {
            const units = state.payload.prtf_achievement_units_attributes;
            const uidx = units.findIndex(u => u.id === unitId || u._index === unitId);
            if (uidx === -1) return;
            const subs = units[uidx].prtf_achievement_subunits_attributes || units[uidx].subunits || [];
            const sidx = subs.findIndex(su => su.id === subunitId || su._index === subunitId);
            if (sidx === -1) return;
            Vue.set(subs[sidx], 'is_hidden', !subs[sidx].is_hidden);
            Vue.set(units[uidx], 'prtf_achievement_subunits_attributes', subs);
        },
    },

    actions: {

        async getAchievementKindLists({commit}, typeId) {
            const response = await PrtfAchKindApiAdmin.index(typeId);
            if(_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("setAchievementKindsList", response.data.achievement_kinds);
            } else {
                this.store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async createAchievementKind({state, dispatch, commit}) {
            state.payload.prtf_achievement_type_id = state.id_achievement_type;
            const response = await PrtfAchKindApiAdmin.create(state.id_achievement_type, state.payload);

            if (!response?.data.hasOwnProperty("error")) {
                commit("unshiftAchievementKindToList", response.data.achievement_kind);
                dispatch('setDialogAction', false);
            } else {
                this.store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async updateAchievementKind({state, commit, dispatch}) {
            state.payload.prtf_achievement_type_id = state.id_achievement_type;
            const response =
                await PrtfAchKindApiAdmin.update(state.id_achievement_type, state.payload.id, state.payload);
            if(_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("replaceAchievementKindToList", response.data.achievement_kind);
                dispatch('setDialogAction', false);
            } else {
                this.store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async deleteAchievementKind({state, commit}, {idType, idKind}) {
            const response = await PrtfAchKindApiAdmin.delete(idType, idKind);
            if(_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("spliceAchievementKindToList", response.data.achievement_kind);
            } else {
                this.store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async setDialogAction(context, flag) {
            if (!flag) {
                context.state.id_achievement_type = null;
                await context.commit('resetAchievement');
                await context.commit('setIdAchievementType', null);
                await context.commit('setIdAchievementKind', null);
                await context.commit("setEditModeForm", false);
            }
            context.commit("setDialog", flag);
        },

        async toggleHiddenAchievementKind({state, commit}, {idType, idKind}) {
            const response = await PrtfAchKindApiAdmin.toggleHiddenAchievementKind(idType, idKind);
            if(_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("replaceAchievementKindToList", response.data.achievement_kind);
            } else {
                this.store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async toggleHiddenAchievementUnit({state, commit}, idUnit) {
            const response = await PrtfAchievementUnitApiAdminService.toggleHiddenAchievementUnit(idUnit);
            if(_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("TOGGLE_UNIT_HIDDEN", idUnit);
            } else {
                this.store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

        async toggleHiddenAchievementSubunit({state, commit}, { unitId, subunitId }) {
            const response = await PrtfAchievementSubunitApiAdminService.toggleHiddenAchievementSubunit(subunitId);
            if(_.isNull(response)) return;

            if (!response?.data.hasOwnProperty("error")) {
                commit("TOGGLE_SUBUNIT_HIDDEN", { unitId, subunitId });
            } else {
                this.store.dispatch("error_portfolio/addError", {
                    type: "Error Server",
                    message: response.data.error.messages,
                    context: "Error Server",
                    show: true
                });
            }
        },

    },
}

export default AchievementKindStore